// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-4c9c0502]:export {\n  menuBg: #393997;\n  menuText: #fff;\n  menuActiveText: #409eff;\n}\n\n/* Mixins */\n.el-table[data-v-4c9c0502] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
